// ======================================================================
// FILE:
// src/modules/service_crm/dashboard/services/dashboardService.js
//
// MODULE: Service CRM
// FEATURE: Dashboard APIs
// ======================================================================

import axiosClient from "../../../../api/axiosClient";


// ======================================================================
// DASHBOARD SUMMARY
// ======================================================================
const getSummary = async (params = {}) => {

  const res = await axiosClient.get(
    "/api/service-crm/dashboard/summary",
    {
      params,
    }
  );

  return res.data.data;
};


// ======================================================================
// STATUS DISTRIBUTION
// ======================================================================
const getStatusDistribution = async (
  params = {}
) => {

  const res = await axiosClient.get(
    "/api/service-crm/dashboard/status-distribution",
    {
      params,
    }
  );

  return res.data.data || [];
};


// ======================================================================
// SLA PERFORMANCE
// ======================================================================
const getSlaPerformance = async (
  params = {}
) => {

  const res = await axiosClient.get(
    "/api/service-crm/dashboard/sla-performance",
    {
      params,
    }
  );

  return res.data.data;
};


// ======================================================================
// TICKET TREND
// ======================================================================
const getTicketTrend = async (
  params = {}
) => {

  const res = await axiosClient.get(
    "/api/service-crm/dashboard/ticket-trend",
    {
      params,
    }
  );

  return res.data.data || [];
};


// ======================================================================
// ENGINEER WORKLOAD
// ======================================================================
const getEngineerWorkload = async (
  params = {}
) => {

  const res = await axiosClient.get(
    "/api/service-crm/dashboard/engineer-workload",
    {
      params,
    }
  );

  return res.data.data || [];
};

// ======================================================================
// ENGINEER PERFORMANCE
// ======================================================================
const getEngineerPerformance = async (
  params = {}
) => {

  const res = await axiosClient.get(
    "/api/service-crm/dashboard/engineer-performance",
    {
      params,
    }
  );

  return res.data.data || [];
};

// ======================================================================
// CUSTOMER EXPERIENCE
// ======================================================================
const getCustomerExperience = async (
  params = {}
) => {

  const res = await axiosClient.get(
    "/api/service-crm/dashboard/customer-experience",
    {
      params,
    }
  );

  return res.data.data;
};



// ======================================================================
// TICKET AGING
// ======================================================================
const getTicketAging = async (
  params = {}
) => {

  const res = await axiosClient.get(
    "/api/service-crm/dashboard/ticket-aging",
    {
      params,
    }
  );

  return res.data.data;
};


// ======================================================================
// PENDING ACTIONS
// ======================================================================
const getPendingActions = async (
  params = {}
) => {

  const res = await axiosClient.get(
    "/api/service-crm/dashboard/pending-actions",
    {
      params,
    }
  );

  return res.data.data;
};

// ======================================================================
// DASHBOARD DRILLDOWN
// ======================================================================
const getDashboardDrilldown = async (
  params = {}
) => {

  const res = await axiosClient.get(
    "/api/service-crm/dashboard/drilldown",
    {
      params,
    }
  );

  return res.data.data || [];
};

// ======================================================================
// EXPORT
// ======================================================================
const dashboardService = {

  getSummary,

  getStatusDistribution,

  getSlaPerformance,

  getTicketTrend,

  getEngineerWorkload,

  getEngineerPerformance,

  getCustomerExperience,

  getTicketAging,

  getPendingActions,
  getDashboardDrilldown,
};

export default dashboardService;